import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { resolveActiveAccount } from '../utils/authSession';

/**
 * ProtectedRoute component that ensures only authenticated users can access certain routes
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { instance } = useMsal();

  // Ensure we have an active account set
  useEffect(() => {
    const ensureActiveAccount = async () => {
      resolveActiveAccount(instance);
    };
    
    ensureActiveAccount();
  }, [instance]);

  return (
    <>
      <AuthenticatedTemplate>
        {children}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/login" state={{ from: location }} replace />
      </UnauthenticatedTemplate>
    </>
  );
};

export default ProtectedRoute;
